import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function StaffIcon(props) {
    return (
        <SvgIcon {...props}>
            <path clipRule="evenodd" d="M10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5C6 3.89543 6.89543 3 8 3C9.10457 3 10 3.89543 10 5ZM16.5001 6C15.5718 6 14.6816 6.36875 14.0252 7.02513C13.3688 7.6815 13.0001 8.57174 13.0001 9.5V11L20.0001 11V9.5C20.0001 8.57174 19.6314 7.6815 18.975 7.02513C18.3186 6.36875 17.4284 6 16.5001 6ZM12 11C12 10.2044 11.6839 9.44129 11.1213 8.87868C10.5587 8.31607 9.79565 8 9 8L7 8C6.20435 8 5.44129 8.31607 4.87868 8.87868C4.31607 9.44129 4 10.2044 4 11L4 14H6L6 20C6 20.2652 6.10536 20.5196 6.29289 20.7071C6.48043 20.8946 6.73478 21 7 21H9C9.26522 21 9.51957 20.8946 9.70711 20.7071C9.89464 20.5196 10 20.2652 10 20L10 14L16 14V12L12 12L12 11Z" fill="#62666B" fillRule="evenodd" />
        </SvgIcon>
    );
}

export default StaffIcon;
